import { render, staticRenderFns } from "./Quiz_Notice_Write.vue?vue&type=template&id=38c466ae&scoped=true&"
import script from "./Quiz_Notice_Write.vue?vue&type=script&lang=js&"
export * from "./Quiz_Notice_Write.vue?vue&type=script&lang=js&"
import style0 from "./Quiz_Notice_Write.vue?vue&type=style&index=0&id=38c466ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c466ae",
  null
  
)

export default component.exports